/* tslint:disable */
/* eslint-disable */
/**
 * Marsinet API
 * Esta API es utilizada tanto por Marsinet como por MarsiConnect. Proporciona todos los endpoints actualizados y documentación detallada, incluyendo ejemplos de datos y mocks de prueba para verificar el comportamiento de cada llamada.
 *
 * OpenAPI spec version: 5.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 *
 *
 * @export
 * @interface OtaUploadBody
 */
export interface OtaUploadBody {
  /**
   * Firmware file (binary)
   *
   * @type {Blob}
   * @memberof OtaUploadBody
   */
  file: Blob;

  /**
   * Software type identifier: 0=CM7, 1=CM4, 2=ESP
   *
   * @type {number}
   * @memberof OtaUploadBody
   */
  software_type: OtaUploadBodySoftwareTypeEnum;

  /**
   * Optional semantic version (e.g., 1.2.3). If not provided, will be extracted from filename or defaults to 1.0.0
   *
   * @type {string}
   * @memberof OtaUploadBody
   * @example 1.2.3
   */
  version?: string;

  /**
   * SHA256 checksum of the file in hexadecimal format for integrity verification
   *
   * @type {string}
   * @memberof OtaUploadBody
   * @example a665a45920422f9d417e4867efdc4fb8a04a1f3fff1fa07e998e86f7f7a27ae3
   */
  checksum?: string;

  /**
   * Optional firmware metadata as JSON string (extracted from binary file). Contains: projectName, binaryVersion, boardVersion, microcontrollerID, creationDateTime
   *
   * @type {string}
   * @memberof OtaUploadBody
   * @example {"projectName":"EXP_CEB","binaryVersion":"v4.1.1-59-g64f4989-dirty","boardVersion":"CEBv3C","microcontrollerID":"0x7450","creationDateTime":"2026-05-27 12:09:23"}
   */
  file_metadata?: string;

  /**
   * Optional authorization token from admin. If provided, upload will be validated against the token.
   *
   * @type {string}
   * @memberof OtaUploadBody
   * @example ota_a1b2c3d4e5f6g7h8i9j0k1l2m3n4o5p6
   */
  upload_token?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum OtaUploadBodySoftwareTypeEnum {
  NUMBER_0 = 0,
  NUMBER_1 = 1,
  NUMBER_2 = 2,
}
